export default __webpack_public_path__ + "static/media/cross.a2abcc6f.svg";